enum EntityValidationErrorUsageEnum {
  EDIT,
  CONFIRM_OR_REFUSE,
  SELECT,
}

export default EntityValidationErrorUsageEnum
